import useRedirectorUrl from 'Hooks/useRedirectorUrl'
import { notifyParent } from 'mailup-react-helpers'
import { PageHeader } from 'mailup-web-components'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { pageState } from '../recoil/state/page'

const Header = () => {
  const intl = useIntl()
  const history = useHistory()
  const [redirectUrl] = useRedirectorUrl()

  const { title, loading, loaded } = useRecoilValue(pageState)

  const goToWorkflowsList = () => {
    history.push('/automation/workflows/list')
  }

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Automation' }),
      'data-mu-test': 'breadcrumb-item__automation',
      className: 'test-breadcrumb-item__automation'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.AutomationWorkflows' }),
      'data-mu-test': 'breadcrumb-item__automation-workflow',
      className: 'test-breadcrumb-item__automation-workflow',
      url: '#',
      onClick: goToWorkflowsList
    },
    {
      label: intl.formatMessage({ id: 'Load.MailupCommon.ActionStatistics' }),
      'data-mu-test': 'breadcrumb-item__statistics'
    }
  ]

  useEffect(() => {
    notifyParent('selectMenuItemReact', [
      'AutomationWorkflowTroubleshooting',
      redirectUrl
    ])
  }, [redirectUrl])

  return (
    <PageHeader
      loading={loading && !loaded}
      title={title}
      breadcrumbsItems={breadcrumbsItems}
    />
  )
}

export default Header
